import { DownloadIcon } from '@ui/kit/icons';
import { UniversalContextMenuButton } from '@utils/component-framework';
import { jsx } from 'react/jsx-runtime';

function PdfDownloadButton({
  downloadUrl
}) {
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "a",
    label: "Download PDF",
    icon: /*#__PURE__*/jsx(DownloadIcon, {}),
    href: downloadUrl,
    target: "_blank",
    rel: "noreferrer noopener",
    download: true
  });
}

export { PdfDownloadButton };
//# sourceMappingURL=pdf-download-button.js.map
